import { DATA_GIF_PATH } from "../../utils/config";
import GxBlackButtonSmall from "../../components/common/actions/buttons/GxBlackButtonSmall";
import { t } from "i18next";

interface SuccessModalBulkUploadProps {
  onClose: () => void;
  isOpen: boolean;
  successData?: {
    aprdStatus: "A" | "R";
    gxChnNo?: string;
  };
  successMessage?: string;
  bulkApproveCount?: string;
  onNavigate?: () => void;
}

export default function SuccessModalBulkUpload({
  isOpen,
  onClose,
  successData,
  bulkApproveCount,
  onNavigate,
}: Readonly<SuccessModalBulkUploadProps>) {
  if (!isOpen) return null;

  const isBulkAction = !!bulkApproveCount;
  const isApproved = successData?.aprdStatus === "A";

  const handleClose = () => {
    onClose();
    if (onNavigate && isApproved) {
      onNavigate();
    }
  };

  const getTitle = () => {
    if (isBulkAction) {
      return isApproved
        ? t("bulk_uploads_approved")
        : t("bulk_uploads_rejected");
    }
    return isApproved ? t("bulk_upload_approved") : t("bulk_upload_rejected");
  };

  const getDescription = () => {
    if (isBulkAction) {
      return isApproved
        ? `${t("successfully_approved")} ${bulkApproveCount} ${t("bulk_uploads")}.`
        : `${t("successfully_rejected")} ${bulkApproveCount} ${t("bulk_uploads")}.`;
    }

    const refNo = successData?.gxChnNo || t("the_bulk_upload_");
    return isApproved
      ? `${t("the_bulk_upload")} ${refNo} ${t("has_been_successfully_approved")}`
      : `${t("the_bulk_upload")} ${refNo} ${t("has_been_rejected_necessary_corrections")}`;
  };

  const getGif = () => `${DATA_GIF_PATH}done_animation.gif`;

  return (
    <div className="gx-custom-remark-modal-background-t">
      <div className="gx-custom-remark-modal-conatiner">
        <div className={`gx-custom-remark-modal ${isOpen ? "show" : "hide"}`}>
          <main className="gx-custom-remark-modal-main">
            <div className="gx-animation-wrapper-s">
              <img
                src={getGif()}
                alt="Status"
                className="gx-success-animation"
              />
            </div>
            <div className="flex justify-center">
              <span className="gx-message gx-font-regular">{getTitle()}</span>
            </div>
            <div className="mt-4 flex justify-center">
              <p className="text-[#4d4d4d] text-[0.75rem] gx-font-medium text-center px-4">
                {getDescription()}
              </p>
            </div>
            {isBulkAction && (
              <div className="mt-2 flex justify-center">
                <span className="text-[#2196f3] text-[0.875rem] gx-font-semibold">
                  {bulkApproveCount}
                </span>
              </div>
            )}
          </main>
          <footer className="gx-custom-remark-modal-footer">
            <div className="space-x-4">
              <GxBlackButtonSmall onClick={handleClose}>
                {t("close")}
              </GxBlackButtonSmall>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}
